import type { ActorDatabaseHandle } from "@-/dev.improve.haniverse.database.actor";
import { actorSchema } from "@-/dev.improve.haniverse.database.schemas.actor.schema";
import { rewardDayKey } from "#daily-login-reward";

/**
 * Grants Han, HanMiles and/or dragons outright, as a `grant` reward row. Used by internal tooling
 * and QA accounts (e.g. the Maestro travel flow tops the wallet up so every fare is affordable).
 */
export async function grantHan({
  actorDb,
  dragons = 0,
  han,
  hanMiles = 0,
  id,
  now,
}: {
  actorDb: ActorDatabaseHandle;
  dragons?: number;
  han: number;
  hanMiles?: number;
  /** A deterministic id makes the grant idempotent. */
  id: string;
  now: Date;
}): Promise<void> {
  const nowIso = now.toISOString();
  await actorDb
    .insert(actorSchema.rewardClaim)
    .values({
      claimedAt: nowIso,
      claimedOn: rewardDayKey(now),
      createdAt: nowIso,
      dragonAmount: dragons,
      hanAmount: han,
      hanMilesAmount: hanMiles,
      id,
      kind: "grant",
    })
    .onConflictDoNothing()
    .run();
}
